exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal-body__container{max-height:100vh;padding-bottom:16px}.modal-body__container .modal-content{max-height:100%}.modal-body__container .modal-dialog{height:100%}.modal-body__container .modal-body{overflow:auto}", ""]);
